import React from 'react';

import css from './SectionArtistProfiles.module.css';
import { H2 } from '../../../components';
import classNames from 'classnames';

const items = [
  'HowItWorksPage.artistProfiles.info.1',
  'HowItWorksPage.artistProfiles.info.2',
  'HowItWorksPage.artistProfiles.info.3',
  'HowItWorksPage.artistProfiles.info.4',
  'HowItWorksPage.artistProfiles.info.5',
  'HowItWorksPage.artistProfiles.info.6',
  'HowItWorksPage.artistProfiles.info.7',
  'HowItWorksPage.artistProfiles.info.8',
  'HowItWorksPage.artistProfiles.info.9',
  'HowItWorksPage.artistProfiles.info.10',
];

const SectionArtistProfiles = props => {
  const { intl, className, titleClassName } = props;

  return (
    <div className={classNames(css.root, className)}>
      <H2 className={titleClassName}>
        {intl.formatMessage(
          { id: 'HowItWorksPage.artistProfiles.heading' },
          { span: text => <span className={css.marketplaceText}>{text}</span> }
        )}
      </H2>
      <p className={css.belowHeadingText}>
        {intl.formatMessage({ id: 'HowItWorkspage.artistProfiles.belowHeading' })}
      </p>
      <ul className={css.infoList}>
        {items.map(item => (
          <li key={item} className={css.infoItem}>
            {intl.formatMessage(
              { id: item },
              { b: text => <span className={css.boldText}>{text}</span> }
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SectionArtistProfiles;
